import { FormErrorMessage } from "@chakra-ui/react";

interface ReactProps {
  text: string;
}
export function QuestionSearchError({ text }: ReactProps) {
  return <FormErrorMessage>{text}</FormErrorMessage>;
}
